import $ from 'jquery';
import slick from  '../vendors/slider.min';
import SliderPager from './bjzm-slider-pager.js';

class BjzmScripts {
	
	constructor() {
		 this.do_hamburger();
		 this.doSliders();
		 this.doVideoEmbed();
		 this.isHamburgerOpen = false;
		 this.setTouchScreenClasses(".button, .navigation__link");
		 this.mobileHeader = $(".header--mobile")
	}

	doVideoEmbed() {
		$('.hero__video').each(function(e) {

            var $projectItem = $(this).closest('.hero')
            var width = $projectItem.outerWidth();

            var videoId = $(this).data('video-id');
            var autoPlay = false;

            var options = {
                id: videoId,
                width: width,
                loop: false,
                autoplay: false,
                background: true
            };

			var $scrollDown = $(".hero__scroll-down-outer");

            setTimeout(function(){
	            var player = new Vimeo.Player(`hero-video`, options);

            	$projectItem.addClass('hero-loaded');
            	player.on('loaded', function(){
            		setTimeout(function(){
                		$projectItem.addClass('video-is-playing');
                		$('.header--main').addClass('hero-loaded');
                	}, 2200);
                });

                player.on('play', function(){
                	setTimeout(function(){
                		player.pause();
                		$scrollDown.addClass('hero-loaded');
                	}, 22000)
                });

            }, 1400);


        });

	}

	do_hamburger() {
		var self = this;
		$(".hamburger__inner").click(function(e){
			e.preventDefault();
			if( self.isHamburgerOpen ) {
				self.closeMobileMenu();
			}
			else {
				self.openMobileMenu();
			}
		})
	}

	doSliders() {
		var self = this;
		if( $(".bjzm-slideshow__list").length > 0 ) {
			
			var $slider = $(".bjzm-slideshow__list")
			$slider.on('beforeChange', (event, slick, currentSlide, nextSlide) => {
				self.onBeforeChange(event, slick, currentSlide, nextSlide);
			} );
			// setTimeout(function(){
				$slider.on('init', (event, slick) => {
					self.onInit(event, slick);
				});
			// }, 1200);
			$slider.slick({ 
				dots: false,
				centerPadding: 0,
		 		slidesToShow: 1,
		 		variableWidth: true,
		 		adaptiveHeight: true,
		 		arrows: false,
	            dotsClass: 'custom_paging',
	            infinite: true,
	            autoplay: true,
	            autoplaySpeed: 3000,
	            pauseOnHover: true,
	            useCSS: true,
	            centerMode: true,
	            autoplay: false
		 	});
			$(".bjzm-slideshow__nav-link--prev").on('click', function(e){
				e.preventDefault();
				$(".bjzm-slideshow__list").slick('slickPrev');
			})
			$(".bjzm-slideshow__nav-link--next").on('click', function(e){
				e.preventDefault();
				$(".bjzm-slideshow__list").slick('slickNext');
			});
			var sliderPager = SliderPager.getSlidePager( );
			$(".bjzm-slideshow__footer").html(sliderPager);
		} 	
	}

	onBeforeChange(event, slick, currentSlide,  nextSlide) {
		
		var currentSlideCount = currentSlide + 1;
		var currentSlideIndex = currentSlide;
		var slideIndex = nextSlide + 1;

		var $pagerIndex = $('.slide-pager__number--index');
		$pagerIndex.addClass('swipe-up');
		setTimeout(() => {
			$pagerIndex.addClass('come-down');
				$pagerIndex.html(slideIndex);
			setTimeout(() => {
				setTimeout(()=>{
					$pagerIndex.addClass('swipe-down');
				}, 60)
				setTimeout(() => {
					$pagerIndex.removeClass('swipe-up').removeClass('come-down').removeClass('swipe-down');
				}, 200);
			}, 40);
		}, 220);
		$('.bjzm-slideshow__inner--content').addClass('bjzm-slideshow__inner--content--fade-out');
	}

	openMobileMenu() {
		this.mobileHeader.addClass("header--mobile-menu-active");
		this.isHamburgerOpen = true;
	}

	onInit(event, slick) {
		console.log('slick.slideCount', slick.slideCount);
		console.log($('.slide-pager__number--total').length);
    	$('.slide-pager__number--total').html(slick.slideCount);
	}

	closeMobileMenu() {
		this.mobileHeader.removeClass("header--mobile-menu-active");
		this.isHamburgerOpen = false;
	}


	is_touch_device() {
		return (('ontouchstart' in window)
			|| (navigator.MaxTouchPoints > 0)
			|| (navigator.msMaxTouchPoints > 0));
	}

	getTouchClass() {
		return ( this.is_touch_device() ) ? ' touch-screen' : ' desktop-screen';
	}

	setTouchScreenClasses(selectors) {

		console.log('selectors', selectors);
		var classes = this.getTouchClass();
		$(selectors).addClass( classes );
	}

	

	
}

module.exports = BjzmScripts;